// extracted by css-extract-rspack-plugin
export default {"toast":"kzCNag","corner":"iP9yvh","message":"TTL8gP","countdown":"d9jyuW","iconButton":"tbeRKF"};